<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>

    <Sheet.Body class="pb-[calc(env(safe-area-inset-bottom)+16px)]">
      <FromInviteBody :email="email" />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, useSheet } from '@dacr/library'
import { CloseIcon } from '@dacr/icons'

import FromInviteBody from './FromInviteBody.vue'

defineProps<{
  email: string
}>()

const { close } = useSheet()
</script>
